module.exports = __webpack_public_path__ + "img/mobile-phone.9b8cc1ca.svg";